import NavBar from './navbar';
import NavMenu from './navmenu';
import { useAppDispatch, useAppSelector } from '../slices/index';
import { useNavigate } from 'react-router';
import * as UI from '../slices/uiSlice';
import * as Cases from '../slices/casesSlice';
import { AnyAction } from '@reduxjs/toolkit';
import '../App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import leading_the_way from '../assets/Leading_The_Way_Conveyancing.svg';
import icon_team from '../assets/The_Team_White.svg';
import OpenCaseIconBlue from '../assets/open-case-icon-blue.svg';
import CaseDetailsIconBlue from '../assets/case-details-icon-blue.svg';
import ActionsIconBlue from '../assets/actions-icon-blue.svg';
import FormsAndReportsIconBlue from '../assets/forms-and-reports-icon-blue.svg';
import MeetTheTeamIcon from '../assets/meet-the-team-icon.svg';
import WishlistIconBlue from '../assets/wishlist-icon-blue.svg';
import { useEffect } from 'react';

const Team = () => {
	const cases = useAppSelector(state => state.cases);
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const handleScroll = () => {
		dispatch((UI.closeMenu()) as unknown as AnyAction);
	};

	const getTeam = (): Cases.teamState | null => {
		for (const team of cases.teams) {
			if (cases.case.details && (team.handler === cases.case.details.handler)) {
				return team;
			}
		}
		return null;
	}

	const openCase = () => {
		navigate('/case');
	}

	const openCaseDetails = () => {
		navigate('/case-details');
	}

	const openActions = () => {
		navigate('/actions');
	}

	const openHistory = () => {
		navigate('/historylist');
	}

	const openTeam = () => {
		navigate('/team');
	}

	const wishList = () => {
		if (cases.case.details && cases.case.details.wishlisted) {
			dispatch(UI.setWishlistEditPopup({ visible: true, caseno: cases.case.caseno, casetype: cases.case.type }));
		} else {
			dispatch(UI.setWishlistPopup({ visible: true, caseno: cases.case.caseno, casetype: cases.case.type }));
		}
	}

	const team: Cases.teamState | null = getTeam();

	useEffect(() => {
		if (!cases.case.caseno) {
			navigate('/hub');
		}
	}, [])

	return (
		<div className="Home" style={{ position: 'relative' }}>
			<div style={{ position: 'absolute', top: 96, left: 0, right: 0, bottom: 80 }}>
				<div className='OrangeBand'>
					<div style={{ marginLeft: 'calc(10% + 144px)', marginRight: '10%', width: 'calc(80% - 144px)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<img style={{ width: 96, height: 96, marginRight: 8 }} src={icon_team} alt='Team-Icon' />
							<div style={{ marginLeft: 24 }}>
								<div style={{ fontFamily: 'OpenSans-Bold', fontSize: 36, marginBottom: 12, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Meet the Team {cases.case.caseno}</div>
							</div>
						</div>
					</div>
				</div>
				<div className="row100 topButtonContainer" style={{ justifyContent: 'start', alignItems: 'end', position: 'absolute', top: '150px', left: '2%', zIndex: 995 }}>
					<div className='buttonPurpleSecondary' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => openCase()}>
						<div style={{ display: 'flex', alignItems: 'center', minWidth: '40px' }}>
							<img style={{ width: 20, height: 20, marginRight: 8 }} src={OpenCaseIconBlue} alt='OpenCase-Icon' />
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Milestones</div>
						</div>
						<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
							{cases.isOpeningTeam &&
								<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
							}
						</div>
					</div>
					<div className='buttonPurpleSecondary' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => openCaseDetails()}>
						<div style={{ display: 'flex', alignItems: 'center', minWidth: '45px' }}>
							<img style={{ width: 20, height: 20, marginRight: 8 }} src={CaseDetailsIconBlue} alt='CaseDetails-Icon' />
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Case Details</div>
						</div>
						<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
							{cases.isOpeningTeam &&
								<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
							}
						</div>
					</div>
					<div className='buttonPurpleSecondary' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => openActions()}>
						<div style={{ display: 'flex', alignItems: 'center', minWidth: '40px' }}>
							<img style={{ width: 20, height: 20, marginRight: 8 }} src={ActionsIconBlue} alt='Actions-Icon' />
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Actions</div>
							{cases.case.details && cases.case.details.unviewActions.length > 0 && <div style={{ height: '19px', width: '19px', marginLeft: '10px', backgroundColor: 'red', borderRadius: '50%', color: '#FFFFFF', fontSize: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{cases.case.details.unviewActions.length}</div>}
						</div>
						<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
							{cases.isOpeningActions &&
								<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
							}
						</div>
					</div>
					<div className='buttonPurpleSecondary' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => openHistory()}>
						<div style={{ display: 'flex', alignItems: 'center', minWidth: '50px' }}>
							<img style={{ width: 20, height: 20, marginRight: 8 }} src={FormsAndReportsIconBlue} alt='Forms&Reports-Icon' />
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Forms & Reports</div>
						</div>
						<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
							{cases.isOpeningActions &&
								<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
							}
						</div>
					</div>
					<div className='buttonPurple' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => openTeam()}>
						<div style={{ display: 'flex', alignItems: 'center', minWidth: '50px' }}>
							<img style={{ width: 20, height: 20, marginRight: 8 }} src={MeetTheTeamIcon} alt='Team-Icon' />
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Meet the Team</div>
						</div>
						<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
							{cases.isOpeningActions &&
								<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
							}
						</div>
					</div>
					<div className={(cases.case.details?.wishlisted ? 'buttonGreenRounded' : 'buttonPurpleSecondary')} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => wishList()}>
						<div style={{ display: 'flex', alignItems: 'center', minWidth: '40px' }}>
							<img style={{ width: 20, height: 20, marginRight: 8 }} src={WishlistIconBlue} alt='Wishlist-Icon' />
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Wishlist{(cases.case.details?.wishlisted ? ' - ' + cases.case.details.wishlisted : '')}</div>
						</div>
						<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
							{cases.isWishlisting &&
								<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
							}
						</div>
					</div>
				</div>
				<div className='teamsContainer' style={{ position: 'absolute', top: 155, left: 0, right: 0, bottom: 0, overflowY: 'scroll' }} onScroll={handleScroll}>
					<div style={{ maxWidth: 960, padding: '16px 2%', color: 'black', paddingTop: 64 }}>
						{team &&
							<div>
								<div style={{ display: 'flex', margin: '0 0' }}>
									<div style={{ fontFamily: 'OpenSans-Bold', fontSize: 28, color: '#4BC0E1' }}>{team.teamname}</div>
								</div>
								<div style={{ display: 'flex', margin: '0 0', flexWrap: 'wrap', width: '100%' }}>
									<div style={{ display: 'flex', margin: '4px', width: '48%' }}>
										<div style={{ display: 'flex', margin: 4, backgroundColor: '#4BC0E1', width: '100%', borderRadius: 16, alignItems: 'center' }}>
											<div style={{ display: 'flex', alignItems: 'start', margin: '0 0', backgroundColor: 'white' }}>
												<img style={{ width: 128, height: 128, objectFit: 'cover', objectPosition: 'center top', borderTopLeftRadius: 16, borderBottomLeftRadius: 16 }} src={process.env.REACT_APP_API_BACKEND_URL + 'getportrait.php?name=' + encodeURIComponent(team.name)} alt={team.name}></img>
											</div>
											<div style={{ padding: '0 8px', color: 'white' }}>
												<div style={{ fontSize: 28, fontFamily: 'OpenSans-Bold' }}>{team.name?.replace(/[0-9]/g, '')}</div>
												<div style={{ fontSize: 13 }}>{team.job}</div>
											</div>
										</div>
									</div>
									{(team.members || []).map((item: Cases.teamMemberState) => {
										return (
											<div style={{ display: 'flex', margin: '4px', width: '48%' }}>
												<div style={{ display: 'flex', margin: 4, backgroundColor: '#4BC0E1', width: '100%', borderRadius: 16, alignItems: 'center' }}>
													<div style={{ display: 'flex', alignItems: 'start', margin: '0 0', backgroundColor: 'white' }}>
														<img style={{ width: 128, height: 128, objectFit: 'cover', objectPosition: 'center top', borderTopLeftRadius: 16, borderBottomLeftRadius: 16 }} src={process.env.REACT_APP_API_BACKEND_URL + 'getportrait.php?name=' + encodeURIComponent(item.name)} alt={item.name}></img>
													</div>
													<div style={{ padding: '0 8px', color: 'white' }}>
														<div style={{ fontSize: 28, fontFamily: 'OpenSans-Bold' }}>{item.name?.replace(/[0-9]/g, '')}</div>
														<div style={{ fontSize: 13 }}>{item.job}</div>
													</div>
												</div>
											</div>
										)
									})}
								</div>
							</div>
						}
					</div>
				</div>
			</div>

			<div className='mainFooter'>
				<div style={{ marginLeft: '10%', marginRight: '10%', width: '80%', marginTop: 18 }}>
					<img style={{ height: 28 }} src={leading_the_way} alt='LeadingTheWay-Banner' />
				</div>
			</div>
			<div className='loginFooter'></div>
			<NavMenu />
			<NavBar />
		</div>
	);
}

export default Team;